import React from 'react'
import { FloatLabel } from 'primereact/floatlabel'
import { InputTextarea,InputTextareaProps } from 'primereact/inputtextarea'

export type EditableAreaProps = Omit<InputTextareaProps,'onChange'> & {
  label: string
  errors: string | undefined
  onChange?:(_:string) => void
}

export const EditableArea : React.FC<EditableAreaProps> = (props) => {
  return (
    <div className="flex-grow-1">
      <FloatLabel>
        <label htmlFor={props.id}>{props.label}</label>
        <InputTextarea
          {...{ ...props,onChange:(e) => props.onChange ? props.onChange(e.target.value) : undefined } }
        />
      </FloatLabel>
      {!!props.errors &&
        <small id={props.id + '-error'} className="text-danger">
          {props.errors}
      </small>}
    </div>
  )
}

export default EditableArea
